<script>
import { mapActions, mapState } from 'pinia';

import { useUserStore } from '../../../../store/useUserStore.js';
import { SectionPostTypes } from '../../constants';

export default {
  name: 'CpSocialFeedLobbyPost',
  components: {
    CpBaseSvgIcon: require('../../base-svg-icon').default,
    CpSocialShareDialog: require('../../dialogs/social-share').default,
    LikeActionButton: require('../actions/like-action-button').default,
    CpLikesProfiles: require('../../likes/likes-profiles').default,
    CpDialog: require('../../dialog').default,
    CommentActionButton: require('../actions/comment-action-button').default,
    CpCommentsPost: require('../../comments/box-comments').default,
    CpGrid: require('../../grid').default,
    CpGridItem: require('../../grid-item').default,
    EndorseIcon: require('../icons/endorse').default,
    LobbyActionButton: require('../actions/lobby-action-button').default,
    CpLobbyDialog: require('../../dialogs/lobby').default,
    DonateActionButton: require('../../explore-campaigns/actions/donate-action-button').default,
    CpDialogAuthForm: require('../../auth-form/dialog-auth-form').default,
    CpCardHeaderReactions: require('../../components/CardHeaderReactions').default,
    CpShowInteractionsCount: require('../../components/ShowInteractionsCount').default,
    CpLobbyAction: require('../../lawmaker/components/LobbyAction.vue').default,
    handleImageError: require('../../mixins/utils').default,
    CpEndorsesProfiles: require('../../endorses/endorses-profiles').default,
    CpOpposesProfile: require('../../opposes/OpposesProfile').default,
    formatOfficeName: require('../../mixins/utils').default,
  },
  directives: {
    marginTop: require('../../directives/margins').marginTop,
    marginBottom: require('../../directives/margins').marginBottom,
    marginLeft: require('../../directives/margins').marginLeft,
  },
  data() {
    return {
      showLobbyDialog: false,
      showLikesModal: false,
      showVerifyEmailModal: false,
      comments_count: this.lobby.comments_count,
      likes_count: this.lobby.likes_count,
      showAuthModal: false,
      isStartingLobby: false,
      isLoginCallbackActive: false,
      type: SectionPostTypes.LOBBY,
      showEndorsesModal: false,
      showOpposesModal: false,
      endorsesCount: this.lobby.politician.endorses,
      opposesCount: this.lobby.politician.opposes,
    };
  },
  watch: {
    lobby(newResult) {
      this.comments_count = newResult.comments_count;
    },
  },
  props: {
    lobby: Object,
    explore: Boolean,
    forShare: Boolean, //Is shared in explore
    iconState: Boolean,
    user: Object,
  },
  methods: {
    async startLobby() {
      this.isStartingLobby = true;
      if (!this.authUser) {
        this.showAuthModal = true;
      } else {
        this.handleStartLobby();
      }
    },
    handleStartLobby() {
      this.showLobbyDialog = !this.showLobbyDialog;
    },
    handleLikesModal() {
      this.showLikesModal = !this.showLikesModal;
    },
    handleVerifyEmailModal() {
      this.showVerifyEmailModal = !this.showVerifyEmailModal;
    },
    handleCountLikes(value) {
      if (value) {
        this.likes_count = this.likes_count + 1;
      } else {
        this.likes_count = this.likes_count - 1;
      }
    },
    setCount(type) {
      this.comments_count++;
    },
    setCommentsCount(action) {
      action == 'remove' ? this.comments_count-- : this.comments_count++;
    },
    profile(slug) {
      if (slug) {
        return '/profile/' + slug;
      }
      return null;
    },
    handleCloseButton() {
      this.showAuthModal = false;
      if (!this.isLoginCallbackActive && !isSocialLogin) {
        this.isStartingLobby = false;
      }
    },
    loginCallbackAction() {
      this.isLoginCallbackActive = true;
      if (this.isStartingLobby) {
        this.handleStartLobby();
      }
      this.isLoginCallbackActive = false;
    },
    handleEndorsesModal() {
      this.showEndorsesModal = !this.showEndorsesModal;
    },
    handleOpposesModal() {
      this.showOpposesModal = !this.showOpposesModal;
    },
    ...mapActions(useUserStore, ['getUserProfile']),
  },
  computed: {
    authUser() {
      return this.$root.authUser;
    },
    stateIcon() {
      return () => import(`../icons/states/${this.lobby.politician.state?.abbreviation || this.lobby.politician.state}`);
    },
    ...mapState(useUserStore, ['isUserLogin', 'userProfileData']),
  },
};
</script>

<template>
  <div class="social-feed-post-wrapper">
    <!-- TO DO: uncomment this when we implement the new feed logic -->
    <!-- <div v-if="lobby.last_activity && !forShare">
      <CpCardHeaderReactions :post="lobby.last_activity" />
      <hr class="search-results__tick" />
    </div> -->

    <div style="margin-bottom: 10px">
      <CpGrid spread stretch-content justify="spaceBetween">
        <CpGridItem span="content" align="center">
          <a :href="profile(lobby.owner.slug)">
            <img :src="lobby.owner.profile_image" class="image-user-activity" loading="lazy" />
          </a>
          <span class="center-user">
            <a class="content-2 profile-link" :href="profile(lobby.owner.slug)">
              <span>{{ lobby.owner.name }}</span>
            </a>
            <span class="content-1"> {{ lobby.action }}</span>
            <a class="content-2 profile-link" style="margin-left: 5px">
              <span>{{ lobby.politician.full_name }}</span>
            </a>
          </span>
        </CpGridItem>
      </CpGrid>
    </div>

    <CpGrid style="background-color: var(--primary-blue-50); padding: 32px 16px">
      <CpGridItem :span="9">
        <div class="box-name-container">
          <a :href="`officials/${this.lobby.politician.id}`">
            <h3 class="subheadline1 primary-color">
              {{ lobby.politician.full_name }}
            </h3>
            <h3 class="body1 black-color" v-html="formatOfficeName(lobby.politician.office_name)"></h3>
          </a>
          <div v-if="!lobby.politician.deleted_at" class="lobby-action-container">
            <CpLobbyAction :politician="lobby.politician" />
          </div>
        </div>
      </CpGridItem>
      <CpGridItem :span="3">
        <div class="circle-image-container">
          <div class="circle-container">
            <img :src="`${lobby.politician?.large_img || lobby.politician?.image}`" alt="Official's image" @error="handleImageError" loading="lazy" />
          </div>
          <div v-if="iconState && !$root.isSmallDesktop">
            <span class="stateIcon">
              <component v-bind:is="stateIcon" class="primary-color" />
            </span>
          </div>
        </div>
      </CpGridItem>
    </CpGrid>

    <div v-if="!forShare" style="margin-top: 10px !important">
      <CpShowInteractionsCount
        :type="type"
        :id="lobby.id"
        :likesCount="likes_count"
        :endorsesCount="endorsesCount"
        :opposesCount="opposesCount"
        :commentsCount="comments_count"
        :handleLikesModal="handleLikesModal"
        :handleEndorsesModal="handleEndorsesModal"
        :handleOpposesModal="handleOpposesModal"
      />
    </div>

    <CpDialog v-if="showLikesModal">
      <CpLikesProfiles :count-likes="lobby.likes_count" :id="lobby.id" :type="'lobby'" @close="handleLikesModal" />
    </CpDialog>

    <div v-if="!forShare" class="social-feed-post-actions">
      <div class="post-action-button like">
        <LikeActionButton type="lobby" :id="lobby.id" :liked="lobby.liked" :onSuccess="handleCountLikes" />
      </div>
      <!-- <div class="post-action-button like">
                <DonateActionButton
                    :id="lobby.id"
                />
            </div> -->
      <div class="post-action-button comment">
        <CommentActionButton :type="type" :id="lobby.id" />
      </div>
      <div class="post-action-button share">
        <CpSocialShareDialog
          class="feed"
          :allow-share-feed="true"
          share-category="Lobby"
          type="lobby"
          :post="lobby"
          share-button-class="button--noborder"
          :url="lobby.permalink"
          :title="
            lobby.charge == 'senator'
              ? `Senator found via CrowdBlue, the  Social Network For Politics`
              : `Congressman found via CrowdBlue, the  Social Network For Politics`
          "
          :description="
            lobby.charge == 'senator'
              ? `Wanted to share this senator I found on CrowdBlue, the Social Network for Politics.`
              : `Wanted to share this congressman I found on CrowdBlue, the Social Network for Politics.`
          "
          :quote="lobby.politician.full_name"
          hashtags="crowdBlue,politics,crowdfunding"
          twitter-user="crowdblue"
        />
      </div>
      <div v-if="!lobby.politician.deleted_at" class="post-action-button like">
        <LobbyActionButton :id="lobby.politician.id" :handleLobbyDialog="startLobby" />
      </div>
    </div>

    <CpCommentsPost v-show="!forShare" :id="lobby.id" :type="type" :setCount="setCommentsCount" />

    <CpLobbyDialog
      v-if="showLobbyDialog"
      :showDialog="showLobbyDialog"
      :politician="lobby.politician"
      :handleDialog="startLobby"
    />

    <CpDialog v-if="showEndorsesModal && !forShare">
      <CpEndorsesProfiles :count-endorses="endorsesCount" :id="lobby.politician.id" type="officials" lobbyType="endorse" @close="handleEndorsesModal" />
    </CpDialog>
    <CpDialog v-if="showOpposesModal && !forShare">
      <CpOpposesProfile :opposesCount="opposesCount" :id="lobby.politician.id" type="officials" lobbyType="oppose" @close="handleOpposesModal" />
    </CpDialog>
    <CpDialogAuthForm v-if="showAuthModal" :handleCloseButton="handleCloseButton" showSignUp :callback-action="loginCallbackAction" />
  </div>
</template>

<style scoped>
.first-name-candidate {
  margin: 0 0 0 10px;
  font-size: 40px;
  font-weight: normal;
}
.last-name-candidate {
  margin: 0 2px;
  font-size: 40px;
}
.box-name-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.box-type-lobby {
  display: flex;
  align-items: center;
  padding: 8px;
  border: 1px solid var(--neutral3);
  border-radius: 4px;
  background-color: var(--white);
}
.subtitle-candidate-2 {
  font-size: 18px;
  margin: 0 0 0 50px;
  font-weight: 500;
}
.subtitle-candidate-1 {
  font-size: 18px;
  margin: 10px 0 0 30px;
  font-weight: 500;
}
.a-hidden {
  text-decoration: none !important;
}
.candidate-box {
  width: 95%;
  text-align: center;
}
.candidate-profile {
  display: block;
}
.content-1 {
  margin-left: 5px;
}
.candidate-name {
  color: white;
  font-size: 1.17em;
  font-weight: bold;
  margin: 10px 0;
}
.more-candidates {
  color: white;
  margin: 0;
}
.search-results__tick {
  color: #cacaca;
  width: 50px;
}
a.profile-link {
  color: var(--color);
}
.center-user {
  display: flex;
  justify-content: center;
  align-items: center;
}
.image-user-activity {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  margin-right: 10px;
}
.circle-image-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle-container {
  width: 178px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.stateIcon {
  position: absolute;
  right: 0;
  bottom: -20px;
  height: 60px;
}
.lobby-action-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
@media only screen and (min-width: 1024px) and (max-width: 1366px) {
  .subtitle-candidate-1 {
    margin: 0;
  }
  .subtitle-candidate-2 {
    margin: 0;
  }
  .first-name-candidate {
    margin: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .subtitle-candidate-1 {
    text-align: center;
    margin: 10px 0 0 0;
  }
  .subtitle-candidate-2 {
    text-align: center;
    margin: 0 0 20px 0;
  }
}
@media only screen and (max-width: 768px) {
  .subtitle-candidate-1 {
    text-align: center;
    margin: 10px 0 0 0;
  }
  .subtitle-candidate-2 {
    text-align: center;
    margin: 0 0 20px 0;
  }
  .circle-container {
    width: 50px;
    height: 50px;
  }
  .stateIcon {
    left: 50%;
    right: 50%;
  }
}
</style>
